/* ==========================================================================
   TeeFactory custom product section (Dawn-compatible)
   Variant picker + gallery + lightbox + quantity + stock note + AJAX ATC
   ========================================================================== */
(function () {
    'use strict';

    window.visualOptionsConfig = ['view', 'design'];

    /* ---------------------------- money helper ---------------------------- */
    function formatMoney(cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        format = format || window.tfMoneyFormat || '${{amount}}';
        var placeholder = /\{\{\s*(\w+)\s*\}\}/;

        function fmt(num, precision, thousands, decimal) {
            precision = precision == null ? 2 : precision;
            thousands = thousands || ',';
            decimal = decimal || '.';
            if (isNaN(num) || num == null) return 0;
            num = (num / 100.0).toFixed(precision);
            var parts = num.split('.');
            var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            return dollars + (parts[1] ? decimal + parts[1] : '');
        }
        var m = format.match(placeholder);
        var token = m ? m[1] : 'amount';
        var value;
        switch (token) {
            case 'amount_no_decimals':
                value = fmt(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = fmt(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = fmt(cents, 0, '.', ',');
                break;
            case 'amount_with_space_separator':
                value = fmt(cents, 2, ' ', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = fmt(cents, 0, ' ');
                break;
            default:
                value = fmt(cents, 2);
        }
        return format.replace(placeholder, value);
    }

    function priceHTML(v, mf) {
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        var h = '<span class="tf-price' + (onSale ? ' tf-price--on-sale' : '') + '">';
        if (onSale) h += '<s class="tf-price__compare">' + formatMoney(v.compare_at_price, mf) + '</s>';
        h += '<span class="tf-price__current">' + formatMoney(v.price, mf) + '</span>';
        if (onSale) h += '<span class="tf-price__badge">Save ' + formatMoney(v.compare_at_price - v.price, mf) + '</span>';
        return h + '</span>';
    }

    /* ------------------------------ Component ----------------------------- */
    function TFProduct(root) {
        this.root = root;
        this.sectionId = root.getAttribute('data-tf-section-id');
        this.productUrl = root.getAttribute('data-tf-url') || window.location.pathname;

        var galEl = document.querySelector('[data-tf-gallery]');
        try {
            this.gallery = galEl ? JSON.parse(galEl.textContent) : [];
        } catch (e) {
            this.gallery = [];
        }

        this.optbox = root.querySelector('[data-tf-optbox]');
        this.idInput = root.querySelector('[data-tf-id]');
        this.priceEl = root.querySelector('[data-tf-price]');
        this.skuEl = root.querySelector('[data-tf-sku]');
        this.skuWrap = root.querySelector('.tf-product__sku');
        this.form = root.querySelector('[data-tf-form]');
        this.submit = root.querySelector('[data-tf-submit]');
        this.submitText = root.querySelector('[data-tf-submit-text]');
        this.mainImg = root.querySelector('[data-tf-main-img]');
        this.stockNote = root.querySelector('[data-tf-stock-note]');
        this.qtyInput = root.querySelector('[data-tf-qty]');
        this.statusEl = root.querySelector('[data-tf-status]');
        this.mf = window.tfMoneyFormat;
        this.lbIndex = 0;

        this.reqToken = 0;
        this.cache = {};

        if (this.submit && this.submitText) this.submit.setAttribute('data-add-label', this.submitText.textContent.trim());

        this.current = this.readSelectedVariant();

        this.initDescription();
        this.bind();
        this.updateCustomImage();
        this.applyVariant(this.current, true);
        this.initStickyBar();
    }

    TFProduct.prototype.initStickyBar = function () {
        var self = this;
        var bar = document.querySelector('[data-tf-sticky]');
        if (!bar || !this.submit) return;
        this.stickyBar = bar;

        var addBtn = bar.querySelector('[data-tf-sticky-add]');
        var addText = bar.querySelector('[data-tf-sticky-add-text]');
        if (addBtn && addText) addBtn.setAttribute('data-add-label', addText.textContent.trim());
        if (addBtn) addBtn.addEventListener('click', function () {
            self.addToCart();
        });

        var changeBtn = bar.querySelector('[data-tf-sticky-change]');
        if (changeBtn) changeBtn.addEventListener('click', function () {
            var target = self.root.querySelector('.tf-optbox') || self.root.querySelector('[data-tf-form]') || self.submit;
            if (target) target.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });

        // Hidden by default; show once the main Add button has scrolled ABOVE the viewport.
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                var e = entries[0];
                var below = e.boundingClientRect.top > 0; // button still further down (not scrolled to yet)
                var show = !e.isIntersecting && !below;
                bar.classList.toggle('is-visible', show);
                bar.setAttribute('aria-hidden', show ? 'false' : 'true');
            }, {
                threshold: 0
            });
            io.observe(this.submit);
        }

        this.updateSticky(this.current);
    };

    TFProduct.prototype.updateSticky = function (v) {
        var bar = this.stickyBar || document.querySelector('[data-tf-sticky]');
        if (!bar || !v) return;
        var price = bar.querySelector('[data-tf-sticky-price]');
        if (price) price.textContent = formatMoney(v.price, this.mf);
        var vt = bar.querySelector('[data-tf-sticky-variant]');
        if (vt) vt.textContent = (v.options || []).join(', ');
        var img = bar.querySelector('[data-tf-sticky-img]');
        if (img && v.featured_image && v.featured_image.src) {
            img.src = v.featured_image.src.split('?')[0] + '?width=120';
        }
        var addBtn = bar.querySelector('[data-tf-sticky-add]');
        var addText = bar.querySelector('[data-tf-sticky-add-text]');
        if (addBtn) {
            if (v.available) {
                addBtn.removeAttribute('disabled');
                if (addText) addText.textContent = addBtn.getAttribute('data-add-label') || 'Add to Bag';
            } else {
                addBtn.setAttribute('disabled', 'disabled');
                if (addText) addText.textContent = 'Sold Out';
            }
        }
    };

    TFProduct.prototype.updateDesignLinks = function (v) {
        if (!v) return;
        document.querySelectorAll('[data-design-studio-link]').forEach(function (a) {
            try {
                var u = new URL(a.getAttribute('href'), window.location.origin);
                u.searchParams.set('variantId', v.id);
                a.setAttribute('href', u.toString());
            } catch (e) {}
        });
    };

    TFProduct.prototype.initDescription = function () {
        var desc = this.root.querySelector('[data-tf-desc]');
        if (!desc) return;
        var body = desc.querySelector('[data-tf-desc-body]');
        var toggle = desc.querySelector('[data-tf-desc-toggle]');
        if (!body || !toggle) return;

        function check() {
            var overflowing = body.scrollHeight > body.clientHeight + 2;
            if (overflowing) {
                toggle.hidden = false;
            } else {
                toggle.hidden = true;
                desc.classList.remove('is-collapsed');
            }
        }
        check();
        setTimeout(check, 300);
        window.addEventListener('resize', check);

        toggle.addEventListener('click', function () {
            var collapsed = desc.classList.toggle('is-collapsed');
            toggle.textContent = collapsed ? toggle.getAttribute('data-more') : toggle.getAttribute('data-less');
        });
    };

    TFProduct.prototype.bind = function () {
        var self = this;

        this.root.addEventListener('change', function (e) {
            if (e.target && e.target.matches && e.target.matches('[data-tf-option]')) self.onOptionChange();
        });

        /* thumbnails -> swap main image */
        this.root.querySelectorAll('[data-tf-thumb]').forEach(function (btn) {
            btn.addEventListener('click', function () {
                var full = btn.getAttribute('data-full');
                if (self.mainImg && full) {
                    self.mainImg.src = full;
                    self.mainImg.srcset = '';
                    self.mainImg.setAttribute('data-index', btn.getAttribute('data-index'));
                }
                self.setActiveThumb(btn.getAttribute('data-media-id'));
            });
        });

        /* thumbnail scroll arrows (vertical on desktop, horizontal on mobile) */
        var thumbs = this.root.querySelector('[data-tf-thumbs]');
        var up = this.root.querySelector('[data-tf-thumb-up]');
        var down = this.root.querySelector('[data-tf-thumb-down]');

        function isRow() {
            return thumbs && getComputedStyle(thumbs).flexDirection === 'row';
        }

        function step() {
            return isRow() ? Math.max(120, Math.round(thumbs.clientWidth * 0.9)) : Math.max(96, Math.round(thumbs.clientHeight * 0.8));
        }

        function scrollByStep(dir) {
            if (isRow()) thumbs.scrollBy({
                left: dir * step(),
                behavior: 'smooth'
            });
            else thumbs.scrollBy({
                top: dir * step(),
                behavior: 'smooth'
            });
        }

        function updateArrows() {
            if (!thumbs || !up || !down) return;
            if (isRow()) {
                var overflowX = thumbs.scrollWidth - thumbs.clientWidth > 2;
                up.style.display = down.style.display = overflowX ? '' : 'none';
                up.disabled = thumbs.scrollLeft <= 1;
                down.disabled = thumbs.scrollLeft + thumbs.clientWidth >= thumbs.scrollWidth - 1;
            } else {
                var overflowY = thumbs.scrollHeight - thumbs.clientHeight > 2;
                up.style.display = down.style.display = overflowY ? '' : 'none';
                up.disabled = thumbs.scrollTop <= 1;
                down.disabled = thumbs.scrollTop + thumbs.clientHeight >= thumbs.scrollHeight - 1;
            }
        }
        if (thumbs && up && down) {
            up.addEventListener('click', function () {
                scrollByStep(-1);
                setTimeout(updateArrows, 350);
            });
            down.addEventListener('click', function () {
                scrollByStep(1);
                setTimeout(updateArrows, 350);
            });
            thumbs.addEventListener('scroll', updateArrows, {
                passive: true
            });
            window.addEventListener('resize', updateArrows);
            setTimeout(updateArrows, 100);
        }

        /* main image -> open lightbox */
        var mainBtn = this.root.querySelector('[data-tf-main-btn]');
        if (mainBtn) mainBtn.addEventListener('click', function () {
            var idx = self.mainImg ? parseInt(self.mainImg.getAttribute('data-index'), 10) || 0 : 0;
            self.openLightbox(idx);
        });

        /* lightbox controls */
        var lb = document.querySelector('[data-tf-lightbox]');
        if (lb) {
            lb.querySelectorAll('[data-tf-lightbox-close]').forEach(function (el) {
                el.addEventListener('click', function () {
                    self.closeLightbox();
                });
            });
            var prev = lb.querySelector('[data-tf-lightbox-prev]');
            var next = lb.querySelector('[data-tf-lightbox-next]');
            if (prev) prev.addEventListener('click', function () {
                self.stepLightbox(-1);
            });
            if (next) next.addEventListener('click', function () {
                self.stepLightbox(1);
            });

            var zoomBtn = lb.querySelector('[data-tf-lightbox-zoom]');
            var stage = lb.querySelector('[data-tf-lightbox-stage]');
            var img = lb.querySelector('[data-tf-lightbox-img]');

            function toggleZoom() {
                lb.classList.toggle('is-zoomed');
                if (img && !lb.classList.contains('is-zoomed')) img.style.transformOrigin = 'center center';
            }
            if (zoomBtn) zoomBtn.addEventListener('click', toggleZoom);
            if (img) img.addEventListener('click', toggleZoom);
            if (stage) stage.addEventListener('mousemove', function (e) {
                if (!lb.classList.contains('is-zoomed') || !img) return;
                var r = stage.getBoundingClientRect();
                var x = ((e.clientX - r.left) / r.width) * 100;
                var y = ((e.clientY - r.top) / r.height) * 100;
                img.style.transformOrigin = x + '% ' + y + '%';
            });

            document.addEventListener('keydown', function (e) {
                if (lb.hidden) return;
                if (e.key === 'Escape') self.closeLightbox();
                else if (e.key === 'ArrowLeft') self.stepLightbox(-1);
                else if (e.key === 'ArrowRight') self.stepLightbox(1);
            });
        }

        /* quantity */
        var minus = this.root.querySelector('[data-tf-qty-minus]');
        var plus = this.root.querySelector('[data-tf-qty-plus]');
        if (minus) minus.addEventListener('click', function () {
            self.qtyInput.value = Math.max(1, (parseInt(self.qtyInput.value, 10) || 1) - 1);
            self.checkStock();
        });
        if (plus) plus.addEventListener('click', function () {
            self.qtyInput.value = (parseInt(self.qtyInput.value, 10) || 1) + 1;
            self.checkStock();
        });
        if (this.qtyInput) this.qtyInput.addEventListener('input', function () {
            self.checkStock();
        });

        /* AJAX add to cart */
        if (this.form) this.form.addEventListener('submit', function (e) {
            e.preventDefault();
            self.addToCart();
        });

        /* open bulk modal */
        var bulkBtn = this.root.querySelector('[data-tf-open-bulk]');
        if (bulkBtn) bulkBtn.addEventListener('click', function () {
            var modal = document.querySelector('[data-tf-bulk-modal]');
            if (modal) {
                modal.hidden = false;
                document.body.style.overflow = 'hidden';
            }
        });

        /* Start Designing -> smooth-scroll to the inline customiser */
        var designBtn = this.root.querySelector('[data-tf-scroll-customizer]');
        if (designBtn) designBtn.addEventListener('click', function () {
            var box = document.querySelector('[data-tf-customizer]');
            if (!box) return;
            box.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            box.classList.add('tf-customizer--flash');
            setTimeout(function () {
                box.classList.remove('tf-customizer--flash');
            }, 900);
        });
    };

    TFProduct.prototype.setActiveThumb = function (mediaId) {
        this.root.querySelectorAll('[data-tf-thumb]').forEach(function (b) {
            b.classList.toggle('is-active', String(b.getAttribute('data-media-id')) === String(mediaId));
        });
    };

    /* move the vertical thumbnail slider so the active image is in view */
    TFProduct.prototype.scrollThumbIntoView = function (mediaId) {
        var thumbs = this.root.querySelector('[data-tf-thumbs]');
        if (!thumbs) return;
        var active = thumbs.querySelector('[data-tf-thumb].is-active') ||
            thumbs.querySelector('[data-tf-thumb][data-media-id="' + mediaId + '"]');
        if (!active) return;
        var li = active.closest('li') || active;
        var isRow = getComputedStyle(thumbs).flexDirection === 'row';
        if (isRow) {
            var target = li.offsetLeft - (thumbs.clientWidth - li.clientWidth) / 2;
            thumbs.scrollTo({
                left: Math.max(0, target),
                behavior: 'smooth'
            });
        } else {
            var top = li.offsetTop - (thumbs.clientHeight - li.clientHeight) / 2;
            thumbs.scrollTo({
                top: Math.max(0, top),
                behavior: 'smooth'
            });
        }
    };


    /* Disable option values that have no available variant for the current
       combination (out of stock) and mark them with .is-unavailable. */

    /* ------------------- server-driven variant resolution ------------------- */

    TFProduct.prototype.readSelectedVariant = function () {
        var el = this.root.querySelector('[data-tf-selected-variant]');
        if (!el) return null;
        try {
            var v = JSON.parse(el.textContent);
            return (v && v.id) ? v : null;
        } catch (e) {
            return null;
        }
    };

    TFProduct.prototype.selectedOptionValueIds = function () {
        var ids = [];
        this.root.querySelectorAll('[data-tf-option-index]').forEach(function (group) {
            var checked = group.querySelector('input[data-tf-option]:checked');
            var id = checked && checked.getAttribute('data-option-value-id');
            if (id) ids.push(id);
        });
        return ids;
    };

    TFProduct.prototype.onOptionChange = function () {
        var self = this;
        
        // 1. Instantly check for a matching alt-text image BEFORE any AJAX calls.
        this.updateCustomImage();

        var ids = this.selectedOptionValueIds();
        if (!ids.length || !this.sectionId) return;

        var key = ids.join(',');
        var token = ++this.reqToken;

        if (this.cache[key]) {
            this.applySectionHTML(this.cache[key]);
            return;
        }

        if (this.abort && this.abort.abort) this.abort.abort();
        this.abort = ('AbortController' in window) ? new AbortController() : null;

        this.setLoading(true);

        var url = this.productUrl +
            '?section_id=' + encodeURIComponent(this.sectionId) +
            '&option_values=' + encodeURIComponent(key);

        fetch(url, {
            signal: this.abort ? this.abort.signal : undefined
        })
            .then(function (r) {
                if (!r.ok) throw new Error('Section render failed (' + r.status + ')');
                return r.text();
            })
            .then(function (html) {
                if (token !== self.reqToken) return; // a newer click won
                self.cache[key] = html;
                self.applySectionHTML(html);
            })
            .catch(function (err) {
                if (err && err.name === 'AbortError') return;
                console.error('[tf-product] option change failed:', err);
                self.setLoading(false);
                self.applyVariant(self.current, false);
            });
    };

    TFProduct.prototype.setLoading = function (on) {
        if (this.optbox) this.optbox.classList.toggle('is-loading', !!on);
        if (this.submit && on) this.submit.setAttribute('disabled', 'disabled');
        var stickyAdd = this.stickyBar && this.stickyBar.querySelector('[data-tf-sticky-add]');
        if (stickyAdd && on) stickyAdd.setAttribute('disabled', 'disabled');
    };

    /* Pull only the pieces we need out of the re-rendered section.
       DOMParser does not execute scripts, so the customiser / bulk-order /
       lightbox markup in the response is inert. */
    TFProduct.prototype.applySectionHTML = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.querySelector('[data-tf-product]');
        if (!newRoot) {
            this.setLoading(false);
            return;
        }

        var activeId = document.activeElement ? document.activeElement.id : null;

        var newOptbox = newRoot.querySelector('[data-tf-optbox]');
        if (newOptbox && this.optbox) this.optbox.innerHTML = newOptbox.innerHTML;

        var newPrice = newRoot.querySelector('[data-tf-price]');
        if (newPrice && this.priceEl) this.priceEl.innerHTML = newPrice.innerHTML;

        var newJson = newRoot.querySelector('[data-tf-selected-variant]');
        var curJson = this.root.querySelector('[data-tf-selected-variant]');
        if (newJson && curJson) curJson.textContent = newJson.textContent;

        this.setLoading(false);
        this.applyVariant(this.readSelectedVariant(), false);

        if (activeId) {
            var el = document.getElementById(activeId);
            if (el && el.focus) el.focus({
                preventScroll: true
            });
        }
    };

    /* Single place that pushes a variant into every dependent UI bit. */
    TFProduct.prototype.applyVariant = function (v, init) {
        if (this.idInput) this.idInput.value = v ? v.id : '';

        if (!v) {
            this.setUnavailable();
            this.updateSticky(null);
            if (this.stockNote) this.stockNote.hidden = true;
            return;
        }

        this.current = v;

        if (this.skuWrap) {
            if (v.sku) {
                this.skuWrap.hidden = false;
                if (this.skuEl) this.skuEl.textContent = v.sku;
            } else {
                this.skuWrap.hidden = true;
            }
        }

        this.updateAvailability(v);
        this.updateImage(v);
        this.checkStock();
        this.updateSticky(v);
        this.updateDesignLinks(v);

        if (!init) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            u.searchParams.delete('option_values');
            window.history.replaceState({}, '', u);
        }
    };

    TFProduct.prototype.updateAvailability = function (v) {
        if (!this.submit) return;
        if (v.available) {
            this.submit.removeAttribute('disabled');
            if (this.submitText) this.submitText.textContent = this.submit.getAttribute('data-add-label') || 'Add to Bag';
        } else {
            this.submit.setAttribute('disabled', 'disabled');
            if (this.submitText) this.submitText.textContent = 'Sold Out';
        }
    };

    TFProduct.prototype.setUnavailable = function () {
        if (!this.submit) return;
        this.submit.setAttribute('disabled', 'disabled');
        if (this.submitText) this.submitText.textContent = 'Unavailable';
    };

    /* show "exceeds current stock" when qty > tracked stock (deny policy) */
    TFProduct.prototype.checkStock = function () {
        if (!this.stockNote || !this.current) return;
        var v = this.current;
        var qty = this.qtyInput ? (parseInt(this.qtyInput.value, 10) || 1) : 1;
        var tracked = v.inventory_management && v.inventory_management !== '' && v.inventory_policy === 'deny';
        var exceeds = tracked && qty > v.inventory_quantity;
        this.stockNote.hidden = !exceeds;
        if (this.submit && v.available) {
            if (exceeds) {
                this.submit.setAttribute('disabled', 'disabled');
            } else {
                this.submit.removeAttribute('disabled');
            }
        }
    };

    TFProduct.prototype.updateCustomImage = function () {
        var colorVal = '', customVal = '';
        this.root.querySelectorAll('.tf-variant').forEach(function(group) {
            var name = group.getAttribute('data-option-name') || '';
            var checked = group.querySelector('input[data-tf-option]:checked');
            if (checked) {
                var val = checked.value.toLowerCase();
                if (name.includes('color') || name.includes('colour')) {
                    colorVal = val;
                } else if (!name.includes('size')) {
                    // Any option that isn't color or size is treated as the secondary visual option
                    customVal = val;
                }
            }
        });

        if (colorVal && customVal) {
            var slug = (colorVal + '-' + customVal).replace(/\s+/g, '-');
            var thumb = this.root.querySelector('[data-tf-thumb][data-alt="' + slug + '"]');
            if (thumb) {
                thumb.click();
                this.scrollThumbIntoView(thumb.getAttribute('data-media-id'));
                this.customImageSet = true;
                return true;
            }
        }
        this.customImageSet = false;
        return false;
    };

    TFProduct.prototype.updateImage = function (v) {
        if (this.customImageSet) return; // Custom image took priority, skip variant logic

        if (!this.mainImg || !v.featured_image || !v.featured_image.src) return;
        var src = v.featured_image.src;
        var url = src.indexOf('?') > -1 ? src.split('?')[0] : src;
        this.mainImg.src = url + '?width=900';
        this.mainImg.srcset = '';
        var mediaId = v.featured_image.id;
        var gi = this.gallery.findIndex(function (g) {
            return String(g.id) === String(mediaId);
        });
        if (gi > -1) this.mainImg.setAttribute('data-index', gi);
        this.setActiveThumb(mediaId);
        this.scrollThumbIntoView(mediaId);
    };

    /* ------------------------------ lightbox ------------------------------ */
    TFProduct.prototype.openLightbox = function (index) {
        var lb = document.querySelector('[data-tf-lightbox]');
        if (!lb || !this.gallery.length) return;
        lb.classList.remove('is-zoomed');
        this.lbIndex = Math.max(0, Math.min(index, this.gallery.length - 1));
        this.renderLightbox();
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
    };
    TFProduct.prototype.closeLightbox = function () {
        var lb = document.querySelector('[data-tf-lightbox]');
        if (lb) {
            lb.hidden = true;
            lb.classList.remove('is-zoomed');
        }
        document.body.style.overflow = '';
    };
    TFProduct.prototype.stepLightbox = function (dir) {
        if (!this.gallery.length) return;
        var lb = document.querySelector('[data-tf-lightbox]');
        if (lb) lb.classList.remove('is-zoomed');
        this.lbIndex = (this.lbIndex + dir + this.gallery.length) % this.gallery.length;
        this.renderLightbox();
    };
    TFProduct.prototype.renderLightbox = function () {
        var lb = document.querySelector('[data-tf-lightbox]');
        if (!lb) return;
        var img = lb.querySelector('[data-tf-lightbox-img]');
        var item = this.gallery[this.lbIndex];
        if (img && item) {
            img.src = item.full;
            img.alt = item.alt || '';
            img.style.transformOrigin = 'center center';
        }
        var counter = lb.querySelector('[data-tf-lightbox-counter]');
        if (counter) counter.textContent = (this.lbIndex + 1) + ' / ' + this.gallery.length;
        var single = this.gallery.length < 2;
        lb.querySelectorAll('.tf-lightbox__nav').forEach(function (n) {
            n.style.display = single ? 'none' : '';
        });
    };

    /* --------------------------- add to cart ------------------------------ */
    TFProduct.prototype.addToCart = function () {
        var self = this;
        var original = this.submitText ? this.submitText.textContent : '';
        if (this.submit) this.submit.setAttribute('disabled', 'disabled');
        if (this.submitText) this.submitText.textContent = 'Adding...';

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            },
            body: new FormData(this.form)
        })
            .then(function (r) {
                if (!r.ok) return r.json().then(function (d) {
                    throw new Error(d.description || 'Could not add to cart');
                });
                return r.json();
            })
            .then(function () {
                if (self.submit) self.submit.removeAttribute('disabled');
                if (self.submitText) self.submitText.textContent = original;
                if (typeof window.tfOpenCart === 'function') window.tfOpenCart();
                else if (typeof window.tfRefreshCart === 'function') window.tfRefreshCart();
                else window.location.href = root + 'cart';
            })
            .catch(function (err) {
                alert('Error: ' + err.message);
                if (self.submit) self.submit.removeAttribute('disabled');
                if (self.submitText) self.submitText.textContent = original;
            });
    };

    /* -------------------------------- init -------------------------------- */
    function init() {
        document.querySelectorAll('[data-tf-product]').forEach(function (root) {
            if (root.__tfInit) return;
            root.__tfInit = true;
            new TFProduct(root);
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function (e) {
        var root = (e.target || document).querySelector ? (e.target.querySelector('[data-tf-product]') || document.querySelector('[data-tf-product]')) : null;
        if (root) root.__tfInit = false;
        init();
    });
})();